// src/components/getAdjacentCommands.js

import commandList from 'data/commands';

export function getAdjacentCommands(currentPath) {
  const index = commandList.findIndex(cmd => cmd.path === currentPath);
  if (index === -1) return { prev: null, next: null };

  const prev = index > 0 ? commandList[index - 1] : null;
  const next = index < commandList.length - 1 ? commandList[index + 1] : null;

  return { prev, next };
}
